import { useId } from 'react';
import { campaignCopy } from '@discovr/features';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { CONFIRM_WORD, isTypedConfirmMatch } from './typedConfirm';

const copy = campaignCopy.typedConfirm;

export interface TypedConfirmFieldProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  /** Fired on Enter once the word matches. */
  onEnter?: () => void;
  helperText?: string;
  /** Replaces the trailing "to continue" of the label, e.g. "to roll back". */
  labelAfter?: string;
}

export function TypedConfirmField({
  value,
  onChange,
  disabled = false,
  onEnter,
  helperText,
  labelAfter = copy.labelAfter,
}: TypedConfirmFieldProps) {
  const fieldId = useId();
  const helperId = useId();

  return (
    <div className="flex flex-col gap-1.5">
      {/* select-text keeps the word selectable; gap-0 stops Label's flex gap splitting the chip. */}
      <Label htmlFor={fieldId} className="select-text flex-wrap gap-0">
        {copy.labelBefore}&nbsp;
        <code className="rounded-sm bg-muted px-1 py-0.5 text-xs font-medium">{CONFIRM_WORD}</code>
        &nbsp;{labelAfter}
      </Label>
      <Input
        id={fieldId}
        value={value}
        autoComplete="off"
        autoCapitalize="characters"
        spellCheck={false}
        placeholder={CONFIRM_WORD}
        disabled={disabled}
        aria-describedby={helperText ? helperId : undefined}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && onEnter && isTypedConfirmMatch(value)) onEnter();
        }}
      />
      {helperText ? (
        <p id={helperId} className="text-xs text-muted-foreground">
          {helperText}
        </p>
      ) : null}
    </div>
  );
}
